<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<p-fieldset #pnl>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBackClose()"></button>
        </ng-template>

        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>

    <ng-template pTemplate="header">{{title}}</ng-template>
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <div class="card">
                <div class="p-fluid">
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <label for="opt">{{translations.lbl_zonal_coordination}}</label>
                        <strong>México Sur</strong>
                    </div>
                </div>
                <div class="p-fluid">
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <label for="opt">{{translations.lbl_national_coordination}}</label>
                        <strong>Ciudad de México</strong>
                    </div>
                </div>
                <div class="p-fluid">
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <label for="opt">{{translations.lbl_local_coordination}}</label>
                        <strong>San Pedro de los Pinos</strong>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <p-table #dt [value]="guides" [rows]="20" [paginator]="true" [rowHover]="true" [columns]="columns" dataKey="name"
        [globalFilterFields]="columnsFilters"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
        [showCurrentPageReport]="true" styleClass="p-datatable-responsive-demo">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{this.lbl_title}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
            </div>

            <span class="p-input-icon-left">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{col.header}}
                </th>
                <th>
                    {{translations.lbl_actions}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    <div *ngIf="rowData[col.field] != true && rowData[col.field] != false">
                        <span class="p-column-title">{{col.header}}</span>{{rowData[col.field]}}
                    </div>
                    <div *ngIf="rowData[col.field] == true">
                        <i class="pi" ngClass="pi-check-circle true-icon"></i>
                    </div>
                    <div *ngIf="rowData[col.field] == false">
                        <i class="pi" ngClass="pi-times-circle false-icon"></i>
                    </div>
                    <!--  
                    <i class="pi" [ngClass]="{
                                    'pi-check-circle true-icon': sessions[col.id].isAssist,
                                    'pi-times-circle false-icon': !sessions[col.id].isAssist
                                  }"></i>
                     -->
                </td>
                <td>
                    <span class="p-column-title">{{translations.lbl_actions}}</span>
                    <button type="button" pButton pRipple icon="pi pi-list" class="p-button-rounded p-mr-2"></button>
                    <button type="button" pButton pRipple icon="pi pi-search" class="p-button-rounded p-mr-2"></button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                {{translations.lbl_total}} {{guides ? guides.length : 0 }} {{translations.lbl_records}}
            </div>
        </ng-template>
    </p-table>

</p-fieldset>